import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutTariffManagementAdvancedSearch } from "./autogen/AutogenLayoutTariffManagementAdvancedSearch";
import { TariffManagementUtil } from "./TariffManagementUtil";
import { CompanySettings } from "@mcleod/core";

export class TariffManagementAdvancedSearch extends AutogenLayoutTariffManagementAdvancedSearch {

    override onLoad() {
        TariffManagementUtil.setCurrencyTextboxState(this.textboxDefaultCurrency);
        TariffManagementUtil.setCurrencyTextboxState(this.textboxCurrency);
        this.textboxCompareOptionCode.visible = CompanySettings.get()?.comparative_option_rating;
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxQualFactor1. */
    textboxQualFactor1BeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.tli_filter = "qual_factor_1";
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxQualFactor2. */
    textboxQualFactor2BeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.tli_filter = "qual_factor_2";
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxConveyanceTypeCode. */
    textboxConveyanceTypeCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.tli_filter = "conveyance_type";
    }

    textboxCompareOptionCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.tli_filter = "compare_option_code";
    }
}
